{
  "idleStartTime": 1500,
  "idleSessionEndTime": 300,
  "appInsightsInstrumentationKey": "2b712541-06c6-4a12-83c7-803d21bda2f5",
  "knownAuthorities": [
    "capitaschoolattendancetool.b2clogin.com"
  ],
  "redirectUri": "http://localhost:4200/",
  "postLogoutRedirectUri": "http://localhost:4200/",
  "ApiEndpoint": "https://d001-oneapi-api-uks-apim.azure-api.net/education/",
  "APIMSubscriptionKey": "700c8df7ebab4e7ab040b640936cd94c",
  "tenant": "capitaschoolattendancetool.onmicrosoft.com",
  "clientID": "01c7e36e-e3d8-4609-baf3-d06fca482641",
  "scopes": [
    "https://capitaschoolattendancetool.onmicrosoft.com/functionapp/user_acces",
    "offline_access",
    "openid",
    "https://capitaschoolattendancetool.onmicrosoft.com/functionapp/user_impersonation"
  ],
  "signInPolicy": "B2C_1A_MFA_PHONE_OR_EMAIL",
  "resetPasswordPolicy": "B2C_1A_PASSWORDRESET",
  "signInAuthorityUrl": "https://capitaschoolattendancetool.b2clogin.com/capitaschoolattendancetool.onmicrosoft.com/B2C_1A_MFA_PHONE_OR_EMAIL/",
  "resetPasswordAuthorityUrl": "https://capitaschoolattendancetool.b2clogin.com/capitaschoolattendancetool.onmicrosoft.com/B2C_1A_PASSWORDRESET/",
  "navigateToLoginRequestUrl": true,
  "validateAuthority": false,
  "product": "Exclusion",
  "sharedAssetsUrl":"https://d001applauncher.z33.web.core.windows.net"
}
